import { Decimal } from 'decimal.js';
import { z } from 'zod';
export const MoneySchema = z.object({
    amount: z.instanceof(Decimal),
    currency: z.enum(['USD']),
});
/*
 * Formats Money into a localized currency string.
 * @params money - The money object to format
 * @params formatOptions - `Intl.NumberFormatOptions` object to override format settings. Uses the same options as `toLocaleString`.
 */
export function formatMoney(money, formatOptions = {}) {
    return money.amount.toNumber().toLocaleString(['en-US'], {
        style: 'currency',
        currency: money.currency,
        ...formatOptions,
    });
}
//# sourceMappingURL=money.js.map